module.exports = __webpack_public_path__ + "img/home6Img2.37a15a92.png";